import { WaveItem, WaveResponse } from '../../../services/fulfillment/types';

/**
 * Resolve the wave to resume when a pick flow mounts. ALWAYS fetches authoritative current state by
 * id via `fetchWave` — it deliberately takes no wave argument, so a wave handed in through
 * `location.state` can never be used. The History API persists `location.state` across a full page
 * reload, so trusting it would resume from a stale snapshot (captured before any picks) and re-prompt
 * an already-picked order instead of advancing. Returns null when the wave is gone (caller redirects).
 */
export async function loadResumeWave(
  waveId: string | number,
  fetchWave: (id: number) => Promise<WaveResponse | null>,
): Promise<WaveResponse | null> {
  return fetchWave(Number(waveId));
}

export interface PickSegment {
  binCode: string;
  quantity: number;
}

export function derivePickSegments(item: WaveItem): PickSegment[] {
  const pickLocs = item.binLocations
    .filter(l => l.locationType === 'pick' || l.locationType === 'refurbished')
    .sort((a, b) => b.quantity - a.quantity);
  const segments: PickSegment[] = [];
  let remaining = item.quantity;
  for (const loc of pickLocs) {
    if (remaining <= 0) break;
    segments.push({ binCode: loc.binCode, quantity: Math.min(remaining, loc.quantity) });
    remaining -= loc.quantity;
  }
  return segments;
}
